import { styled } from '@mui/material';

export const StyledNotificationsListWrap = styled('ul')(({ theme }) => ({
	padding: '12px 0px',
	margin: 0,
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	listStyleType: 'none',

	[theme.breakpoints.down('sm')]: {
		gap: '8px',
	},
}));
